import { Box, Typography, Button } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import RefreshIcon from "@mui/icons-material/Refresh";
import HomeIcon from "@mui/icons-material/Home";

const ErrorPage500 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [lastPath, setLastPath] = useState("/");

  useEffect(() => {
    // Save the last non-error path, so retry can return there
    const prevPath = sessionStorage.getItem("lastPath");
    if (prevPath && prevPath !== "/error-500") setLastPath(prevPath);
  }, []);

  // Store visited path (done globally if needed)
  useEffect(() => {
    const currentPath = location.pathname;
    if (currentPath !== "/error-500") {
      sessionStorage.setItem("lastPath", currentPath);
    }
  }, [location.pathname]);

  const handleRetry = () => {
    // Try reloading the last visited page
    if (lastPath && lastPath !== "/error-500") {
      navigate(lastPath);
      window.location.reload();
    } else {
      navigate("/");
    }
  };

  return (
    <Box
      sx={{
        height: "100vh",
        backgroundColor: "#f7f8fa",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        px: 2,
      }}
    >
      <Typography
        variant="h2"
        color="error"
        fontWeight={800}
        sx={{ mb: 1, fontSize: { xs: "3rem", md: "4rem" } }}
      >
        500
      </Typography>
      <Typography variant="h5" fontWeight={600} mb={1}>
        Oops! Something went wrong.
      </Typography>
      <Typography variant="body1" color="text.secondary" mb={4}>
        The server encountered an unexpected error. Please try again.
      </Typography>

      <Box sx={{ display: "flex", gap: 2 }}>
        {/* <Button
          variant="contained"
          color="primary"
          startIcon={<RefreshIcon />}
          onClick={handleRetry}
        >
          Retry
        </Button>

        <Button
          variant="outlined"
          color="secondary"
          startIcon={<HomeIcon />}
          onClick={() => navigate("/")}
        >
          Go Home
        </Button> */}
      </Box>
    </Box>
  );
};

export default ErrorPage500;
